/*global angular*/
'use strict'

import _ from 'lodash-node/modern/collection'

angular.module('whirlwind').directive('wwImage', function (elementService) {
  return {
    transclude: true,
    replace: true,
    templateUrl: 'components/ww-image/ww-image.html',
    link (scope, element, attrs) {
      const modifiers = elementService.getComponentAttrs(attrs, 'modifier')

      if (modifiers) {
        _.forEach(modifiers, (modifier) => attrs.$addClass(`ww-image--${modifier}`))
      }
    }
  }
})
